<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import Modal from "./Modal.svelte";
  import Button from "$components/+design-system/Button/Button.svelte";

  export let open: boolean;
  export let title: string;
  export let message: string | undefined = undefined;
  export let confirmLabel: string | undefined = undefined;
  export let danger = false;

  const dispatch = createEventDispatcher();
</script>

<svelte:window
  on:keydown={(e) => {
    if (open && e.key == "Enter") {
      dispatch("confirm");
      open = false;
    } else if (open && e.key == "Escape") {
      dispatch("cancel");
      open = false;
    }
  }}
/>

<Modal bind:open withCloseIcon={false} maxWidth="max-w-[600px]" on:close={() => dispatch("cancel")}>
  <div class="p-6">
    <h3 class="text-lg font-medium text-gray-600 dark:text-gray-200">
      {title}
    </h3>
    <p class="mt-6 text-sm font-medium text-neutral-500 dark:text-neutral-400">
      <slot>
        {message}
      </slot>
    </p>
    <div class="mt-5 flex gap-3">
      <Button
        variant="secondary"
        label="Cancel"
        isFullWidth
        size="large"
        on:click={() => {
          dispatch("cancel");
          open = false;
        }}
      />
      <Button
        variant={danger ? "danger" : "primary"}
        label={confirmLabel ?? "Confirm"}
        isFullWidth
        size="large"
        on:click={() => {
          dispatch("confirm");
          open = false;
        }}
      />
    </div>
  </div>
</Modal>
